export const SHOPIFY_DATA = {
    card: [],
    general: [],
};

// Product is an object that contains only the following attributes:
// * id
// * title
// * price
// * img_url
export function save_gccat_card_data(
    product,
    ispromo,
    position,
    list_name,
    collection_title
) {
    SHOPIFY_DATA.card.push({
        product,
        ispromo,
        position,
        list_name,
        collection_title,
    });
}

export function save_general_data(product, category_name, ispromo, img_url) {
    SHOPIFY_DATA.general.push({
        product: product,
        category: category_name,
        ispromo: ispromo,
        img_url: img_url,
    });
}
